import type {$Fetch} from "nitropack";

export const CompanyDocumentRepository = (client: $Fetch) => ({
    get: (id: string, params: Record<string, any>) => client(`/v2/companies/${id}/documents`, { params }),
    post: (id: string, body?: FormData) => client(`/v2/companies/${id}/documents`, { method: 'POST', body }),
});